import React from "react";

// MUI Comp:
import { IconButton,Button } from "@mui/material";

// Styled comp:
import { styled } from '@mui/material/styles';

// icons
import { IoArrowBack } from "react-icons/io5";
import { IoMdArrowRoundBack } from "react-icons/io";


import { useNavigate } from "react-router";

const NavBackButton = styled(Button)({
        // width:'50px',
        // textAlign:'center',
        // position:'absolute',
        // left:'3%',
        // zIndex:1,
        // height:'50px',
        // top:'3%',
});

function BackButton({sxStyle}) {

const navigate =  useNavigate();


const   onNavBackClick = (oEvent) => {
        navigate(-1);
    }

return(
    <NavBackButton 
        variant="outlined" sx={sxStyle}  onClick={onNavBackClick}>
        <IoMdArrowRoundBack/>
    </NavBackButton>
)

}

export default BackButton;